module.exports = __webpack_public_path__ + "img/wechatPayCode.22da002c.png";